import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const ConfirmDialog = (props) => {
    const {title, children, open, setOpen, onConfirm} = props;
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
        >
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <button
                    className="regularButton remove"
                    onClick={() => setOpen(false)}
                >
                    Ei
                </button>
                <button
                    className="regularButton"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                >
                    Jah
                </button>
            </DialogActions>
        </Dialog>
    );
};
export default ConfirmDialog;